import { createEnv } from '@t3-oss/env-core';
import { z } from 'zod';

export const env = createEnv({
	server: {},
	clientPrefix: 'VITE_',
	client: {
		VITE_API_URL: z.string().min(1),
		VITE_ENV: z.enum(['Dev', 'Test', 'Stage', 'Prod']),
		VITE_MSAL_CLIENT_ID: z.string().min(1),
	},

	runtimeEnv: import.meta.env,

	emptyStringAsUndefined: true,
});
